import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';
import Lightbox from 'react-image-lightbox';

import { firebaseStorage } from '../../config/constants';

class NewsImage extends React.PureComponent {
  static propTypes = {
    newsId: PropTypes.string.isRequired,
    themeType: PropTypes.string.isRequired,
    themeId: PropTypes.string.isRequired,
    ext: PropTypes.string.isRequired,
    forcedFileRef: PropTypes.string,
  };

  static defaultProps = {
    forcedFileRef: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      url: null,
      isOpen: false,
    };
  }

  componentDidMount() {
    firebaseStorage.ref(this.props.forcedFileRef || `${this.props.themeType}/${this.props.themeId}/${this.props.newsId}.${this.props.ext}`)
      .getDownloadURL().then(url => this.safeSetState({ url })).catch(error => console.log(error.code));
  }

  componentWillUnmount() {
    this.safeSetState = () => null;
  }

  safeSetState = state => this.setState(state);

  render() {
    const { isOpen } = this.state;

    return (
      <div className="heightLimitedImage500">
        <Image as="a" wrapped centered src={this.state.url} onClick={() => this.setState({ isOpen: true })} />
        {isOpen && (
          <Lightbox
            mainSrc={this.state.url}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </div>
    );
  }
}

export default NewsImage;



// WEBPACK FOOTER //
// ./src/components/News/NewsImage.js